// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"80f00e0d","703":"efb842f9"}[chunkId] + ".chunk.js";
};